var map = {
	"./add.png": 123,
	"./arrows.svg": 124,
	"./cabinet.svg": 125,
	"./cart.svg": 126,
	"./error.svg": 127,
	"./help.svg": 128,
	"./icon1.svg": 129,
	"./icon2.svg": 130,
	"./icon3.svg": 131,
	"./icon4.svg": 132,
	"./icon5.svg": 133,
	"./key.svg": 134,
	"./left-arrow.png": 135,
	"./loupe.svg": 136,
	"./menu-arrow.png": 137,
	"./menu-h1.svg": 138,
	"./phone.svg": 139,
	"./play.svg": 140,
	"./remove.png": 141,
	"./remove.svg": 142,
	"./sprite1.png": 143,
	"./user.svg": 144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;